import { template as template_136c65eae38a4551bf5def05129921fb } from "@ember/template-compiler";
import TaskVariablesConfig from 'eflex/components/task-variables-config';
export default template_136c65eae38a4551bf5def05129921fb(`
<TaskVariablesConfig
  @form={{@form}}
  @disabled={{@disabled}}
  @task={{@task}}
  @taskConfig={{@taskConfig}}
/>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
